// extracted by mini-css-extract-plugin
export default {"banner":"ReadOnlyBanner_banner__hk19B","warn":"ReadOnlyBanner_warn__2TVu+","trashed":"ReadOnlyBanner_trashed__2kbnp"};